export default __webpack_public_path__ + "noisefix.gif";